import { useTranslation } from "react-i18next";

import NavBar from '../components/NavBar';
import Product from '../components/Product';
import ProductSeparator from '../components/ProductSeparator';
import ProductHeader from '../components/ProductHeader';


import USBconfigIMG from '../img/usb_conf.png';
import REDP from '../img/redp.png';

import PhoneIMG from '../img/phone.png';
import PhoneCatalog from '../docs/1.pdf';

import PcuIMG from '../img/PCU.png';
import PcuCatalog from '../docs/2.pdf';

import LaIMG from '../img/LA.png';
import LaCatalog from '../docs/3.pdf';

import EcuIMG from '../img/ECU.png';
import EcuCatalog from '../docs/4.pdf';

import IpeIMG from '../img/IPE.png';
import IpeCatalog from '../docs/5.pdf';

import IpiIMG from '../img/IPI.png';
import IpiCatalog from '../docs/6.pdf';

import IpluIMG from '../img/IPLU.png';
import IpluCatalog from '../docs/7.pdf';

import CslIMG from '../img/CSL.png';
import CslCatalog from '../docs/8.pdf';

import NslIMG from '../img/NSL.png';
import NslCatalog from '../docs/9.pdf';

import PruIMG from '../img/PRU.png';
import PruCatalog from '../docs/13.pdf';

import SigIMG from '../img/SIG.png';
import SigCatalog from '../docs/12.pdf';

import Re1IMG from '../img/RE1.png';
import Re1Catalog from '../docs/11.pdf';

import JRUmemIMG from '../img/jru_mem.png';
import JRUmemCatalog from '../docs/mem_manual.pdf';

import TslIMG from '../img/TSL.png';
import TslCatalog from '../docs/14.pdf';

import KslIMG from '../img/KSL.png';
import KslCatalog from '../docs/15.pdf';

import RJIIMG from '../img/RJI.jpg';

export default function ProductPage() {
  const { t } = useTranslation();


  return (
    <div class="grid">
      <div class="flex justify-center flex-wrap lg:mx-24 mb-4 px-5">
        <ProductHeader/>
        <ProductSeparator name={t("hw_recording_units")}/>
        <Product name="RE1xx" title2="TRU,JRU,CPM,DEADMAN SYSTEM" description={t("p12")} img={Re1IMG} catalog={Re1Catalog}/>
        <Product name="RE DataPack" description={t("p13")} img={REDP} tansparent={true}/>
        <Product name="JRUmem2" title2={t("contained_in") + " REDataPack2"} description={t("p14")} img={JRUmemIMG} tansparent={true} demo="https://heidal.trameco.cz/prezentace/1/" /*manual={JRUmemCatalog}*/ />
        <Product name="USBconfig" title2={t("contained_in") + " REDataPack2"} description={t("p15")} img={USBconfigIMG} tansparent={true}/>

        <ProductSeparator name={t("hw_lights")}/>
        <Product name="CSL-2809-24-110-01.xy" description={t("p8")} img={CslIMG} catalog={CslCatalog}/>
        <Product name="NSL1xyab"   description={t("p9")} img={NslIMG} catalog={NslCatalog}/>
        <Product name="TSLabc.xy"  description={t("p17")} img={TslIMG} catalog={TslCatalog}/>
        <Product name="KSLxyab-c"  description={t("p18")} img={KslIMG} catalog={KslCatalog}/>

        <ProductSeparator name={t("hw_acustic")}/>
        <Product name="TPUabc-z"   description={t("p1")} img={PhoneIMG} catalog={PhoneCatalog}/>
        <Product name="LAabc-z"    description={t("p3")} img={LaIMG} catalog={LaCatalog}/>
        <Product name="ECUabc-z"   description={t("p4")} img={EcuIMG} catalog={EcuCatalog}/>
        <Product name="PCUabc.x-z" description={t("p2")} img={PcuIMG} catalog={PcuCatalog}/>

        <ProductSeparator name={t("hw_optic")}/>
        <Product name="IPE"        description={t("p5")} img={IpeIMG} catalog={IpeCatalog}/>
        <Product name="IPI"        description={t("p6")} img={IpiIMG} catalog={IpiCatalog}/>
        <Product name="IPLU"       description={t("p7")} img={IpluIMG} catalog={IpluCatalog}/>
        <Product name="PRU"        description={t("p10")} img={PruIMG} catalog={PruCatalog}/>
        <Product name="SIG"        description={t("p11")} img={SigIMG} catalog={SigCatalog}/>
        <Product name="RJI"        description={t("p19")} img={RJIIMG} tansparent={true} new_product={true}/>

      
      </div>
      <NavBar location="products" />  {/*je až nakonci aby byl opravdu nad všemi elementy */}
    </div>
  )
}